const requestStateValidator = require('../../../../shared/requests/stateValidator');

export default function() {
  return requestStateValidator;
}

